export const getStepCount = () => 14;
